import { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ModulesContext = createContext({ modules: { empresas: true, contatos: true, produtos: true }, refreshModules: () => {} });

export function ModulesProvider({ children }) {
  const [modules, setModules] = useState({ empresas: true, contatos: true, produtos: true });

  const refreshModules = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/modules`, { withCredentials: true });
      const map = {};
      (res.data || []).forEach(m => { map[m.module] = m.enabled; });
      setModules({
        empresas: map.empresas !== false,
        contatos: map.contatos !== false,
        produtos: map.produtos !== false,
      });
    } catch {}
  }, []);

  useEffect(() => { refreshModules(); }, [refreshModules]);

  return (
    <ModulesContext.Provider value={{ modules, refreshModules }}>
      {children}
    </ModulesContext.Provider>
  );
}

export function useModules() {
  return useContext(ModulesContext);
}
